import Register from '@/app/auth/register'

export default Register
